import { removeStylesFromEditorV3 } from "@azu-business/editor-v3";
import { AioExternalReplacements, AitTableData } from "aic";
import { STYLES_TO_CLEAN, STYLES_TO_DELETE } from "../../../config";
import { removeStylesFromRowGroup } from "./removeStylesFromRowGroup";

/**
 * Removes Optional and Notes styles from TLF table data (used in Body section).
 * If external lists are provided, passes them down to header/row group processing where they are merged with internal replacements.
 * Processes the header group, all body row groups, and table comments.
 *
 * Note: External singles with styles are NOT applied here. They should be promoted to
 * TLF-level singles separately (see RemoveStylesModal for reference).
 *
 * @template T - Content type for table cells and comments
 * @param tableData - The TLF table data to process
 * @param externalLists - Optional array of external list replacements to merge with internal replacements
 * @returns A new table data object with styles removed from all sections
 */
export const removeStylesFromTableData = <T>(
  tableData: AitTableData<T>,
  externalLists?: AioExternalReplacements<T>[],
): AitTableData<T> => {
  return {
    ...tableData,
    headerData: tableData.headerData
      ? removeStylesFromRowGroup(tableData.headerData, externalLists)
      : tableData.headerData,
    bodyData: tableData.bodyData.map((rowGroup) =>
      removeStylesFromRowGroup(rowGroup, externalLists),
    ),
    comments: removeStylesFromEditorV3(tableData.comments, STYLES_TO_DELETE, STYLES_TO_CLEAN),
  };
};
